import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { FadeLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { setAccessToken } from "../redux/featuresSlice/commonSlice";
import { useTranslation } from "react-i18next";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.3)",
  zIndex: 9999,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const Layout = () => {
  const statusLoading = useSelector((state) => state.common.statusLoading);
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    const token = sessionStorage.getItem("accessToken");
    if (token) {
      dispatch(setAccessToken(token));
    }
  }, [dispatch]);
  useEffect(() => {
    if (i18n.language !== "en") {
      i18n.changeLanguage("en");
    }
  }, [i18n]);
  return (
    <>
      {statusLoading && (
        <div style={overlayStyle}>
          <FadeLoader color="#3534ff" />
        </div>
      )}
      <Outlet />
      <ToastContainer />
    </>
  );
};

export default Layout;
